import get from 'lodash-es/get';
import { ExportTaskProcessor } from 'app/layout/export-overlay';
import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';

export class BusinessPartnerListCommonExportProcessor extends ExportTaskProcessor {
  constructor() {
    super();
  }

  protected transformForMainSection(item: BusinessPartnerAttributes) {
    return {
      externalKeys: get(item, 'externalKeys.code', '??'),
      name: get(item, 'name', '??'),
      commercialName: get(item, 'commercialName', ''),
      NIT: get(item, 'NIT', ''),
      DNI: get(item, 'DNI', ''),
      companies: this.getCompany(item),
      locationOne: this.getAllCountries(item), 
      locationTwo: this.getAllDepartments(item), 
      locationThree: this.getAllCities(item), 
      locationFour: this.getAllDistricts(item), 
      addressesAddresses: this.getAddresses(item), //addresses.addresses
      types: this.getType(item),
      routes: this.getRoute(item),
      routeArea: get(item, 'routeArea.name', '??'),
      geolocationPoint: this.getGeolocation(item),
      routingSalesOffice: get(item, 'routingSalesOffice.name', '??'),
      paymentCondition: get(item, 'paymentCondition.name', '??'),
      businessPartnerGroup: get(item, 'businessPartnerGroup.name', '??'),
      businessPartnerSubGroup: get(item, 'businessPartnerSubGroup.name', '??'),
      creditLimit: get(item, 'creditLimit', '??'),
    };
  }

  protected transformForPriceListSection(item: BusinessPartnerAttributes) {
    return get(item, 'distributionChains', []).filter((distributionChains) => distributionChains.statusId !== 0).map((distributionChains) => ({
      externalKeys: `${get(item, 'externalKeys.code', '-')}`,
      name: get(item, 'name', '-'),
      distributionChains: `${get(distributionChains, 'name', '')}`,
      ownPriceList: get(distributionChains, 'ownPriceList.name', ''),
      ownDiscountList: `${get(distributionChains, 'ownDiscountList.name', '')}`,
      ownGiftList: get(distributionChains, 'ownGiftList.name', ''),
      alternalPriceList: this.getAlternalListPriceList(distributionChains)
    }));
  }
  
  private getCompany(item: BusinessPartnerAttributes): string {
      let companie = get(item, 'companies', '??');
      if (companie !== '??') {
          if (Array.isArray(companie)) {
              companie = companie.map((companie) => companie.name).join(', ');
          }
      }
      return companie;
  }

  private getType(item: BusinessPartnerAttributes): string {
      let types = get(item, 'types', '??');
      if (types !== '??') {
          if (Array.isArray(types)) {
              types = types.map((types) => types.name).join(', ');
          }
      }
      return types;
  }

  private getRoute(item: BusinessPartnerAttributes): string {
      let routes = get(item, 'routes', '??');
      if (routes !== '??' && Array.isArray(routes)) {
        routes = routes.filter(route => route && typeof route.name === 'string')
        .map(route => route.name)
        .join(', ');
      }
      return routes;
  }

  private getAddresses(item: BusinessPartnerAttributes): string {
      let addresses = get(item, 'addresses', '??');
  
      if (addresses !== '??' && Array.isArray(addresses)) {
          addresses = addresses.map(address => {
              const locationOneName = get(address, 'address', '').trim();
  
              return [locationOneName].filter(Boolean).join(' - ');
          }).join('; ');
      }
  
      return addresses || '??';
  }

  private getLocation(item: BusinessPartnerAttributes): string {
      let addresses = get(item, 'addresses', '??');
  
      if (addresses !== '??' && Array.isArray(addresses)) {
          addresses = addresses.map(address => {
              const locationOneName = get(address, 'locationOne.name', '').trim();
              const locationTwoName = get(address, 'locationTwo.name', '').trim();
              const locationThreeName = get(address, 'locationThree.name', '').trim();
  
              return [locationOneName, locationTwoName, locationThreeName].filter(Boolean).join(' - ');
          }).join('; '); // Separar cada dirección con un "; " en caso de múltiples direcciones.
      }
  
      return addresses || '??';
  }

  private getAllFromAddresses(item: BusinessPartnerAttributes, path: string): string {
    const addresses = get(item, 'addresses', []);
    if (!Array.isArray(addresses)) return '';

    const values = addresses
      .map(addr => get(addr, path, '').trim())
      .filter(Boolean);

    return values.length > 0 ? values.join('; ') : '';
  }

  getAllCountries(item: BusinessPartnerAttributes) {
    return this.getAllFromAddresses(item, 'locationOne.name');
  }

  getAllDepartments(item: BusinessPartnerAttributes) {
    return this.getAllFromAddresses(item, 'locationTwo.name');
  }

  getAllCities(item: BusinessPartnerAttributes) {
    return this.getAllFromAddresses(item, 'locationThree.name');
  }

  getAllDistricts(item: BusinessPartnerAttributes) {
    return this.getAllFromAddresses(item, 'locationFour.name');
  }

  private getGeolocation(item: BusinessPartnerAttributes): string {
      const addresses = get(item, 'addresses', []);
      
      if (!Array.isArray(addresses) || addresses.length === 0) {
          return '??';
      }
  
      const geolocations = addresses
          .map(address => {
              const geolocationPoint = get(address, 'geolocationPoint', []);
              return Array.isArray(geolocationPoint) && geolocationPoint.length > 0 
                  ? geolocationPoint.join(', ') 
                  : null;
          })
          .filter(Boolean); // Elimina valores nulos o vacíos
  
      return geolocations.length > 0 ? geolocations.join('; ') : '??';
  }

  private getAlternalListPriceList(item: BusinessPartnerAttributes): string {
    let alternalPriceList = get(item, 'alternalPriceList', '??');
    if (alternalPriceList !== '??') {
      if (Array.isArray(alternalPriceList)) {
        alternalPriceList = alternalPriceList.map((alternalPriceList) => alternalPriceList.name).join(', ');
      }
    }
    return alternalPriceList;
  }
}